import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "permissions-panel" }
const _hoisted_2 = { class: "row mb-2" }
const _hoisted_3 = { class: "col-sm-8" }
const _hoisted_4 = { class: "text-sm-right col-sm-4" }
const _hoisted_5 = {
  key: 1,
  class: "text-center mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BButton = _resolveComponent("BButton")!
  const _component_BFormCheckbox = _resolveComponent("BFormCheckbox")!
  const _component_BFormGroup = _resolveComponent("BFormGroup")!
  const _component_BCardBody = _resolveComponent("BCardBody")!
  const _component_BCard = _resolveComponent("BCard")!
  const _component_BOverlay = _resolveComponent("BOverlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t("permissionPanel.permissionsManagement")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_BButton, {
          disabled: !_ctx.isDirty,
          class: "pull-right",
          size: "sm",
          variant: "light",
          onClick: _ctx.onReset
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "times" })
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_BButton, {
          disabled: !_ctx.isDirty,
          class: "pull-right ml-1",
          size: "sm",
          variant: "primary",
          onClick: _ctx.onSave,
          style: {"background-color":"#0054a6"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: "save" })
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    (!_ctx.disabled)
      ? (_openBlock(), _createBlock(_component_BOverlay, {
          key: 0,
          show: _ctx.formLoading,
          rounded: "sm",
          variant: "white",
          opacity: "0.6",
          blur: "2px"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
              return (_openBlock(), _createBlock(_component_BCard, {
                title: group.displayName ?? undefined,
                key: group.name ?? undefined,
                class: "mb-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_BCardBody, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.permissions, (permission) => {
                        return (_openBlock(), _createBlock(_component_BFormGroup, {
                          key: permission.name ?? undefined,
                          class: _normalizeClass(permission.parentName != null ? 'ml-4' : '')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_BFormCheckbox, {
                              modelValue: permission.isGranted,
                              "onUpdate:modelValue": ($event: any) => ((permission.isGranted) = $event),
                              size: "md",
                              switch: ""
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(permission.displayName), 1)
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["show"]))
      : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t("permissionPanel.nothingToShow")), 1))
  ]))
}